module.exports = __webpack_public_path__ + "static/img/admin_banner.89deef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/admin_banner.png
// module id = b62P
// module chunks = 1